module.exports = __webpack_public_path__ + "static/media/appStore.6e452369.png";